import { createTheme } from '@mui/material/styles';
import { red, grey } from '@mui/material/colors';

// Light Theme
const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#ff6d0f', // The orange tone for the header
      contrastText: '#fff',
    },
    secondary: {
      main: '#19857b',
    },
    background: {
      default: '#fff',
      paper: '#f4f4f4', // Sidebar color
    },
    text: {
      primary: '#333', // Text color for items
      secondary: grey[600],
    },
    error: {
      main: red.A400,
    },
  },
  typography: {
    fontFamily: 'Roboto, sans-serif', // Font-family used in the screenshot
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '1rem', // Tooltip font size
          backgroundColor: '#333', // Tooltip background color
          color: '#fff', // Tooltip text color
        },
        arrow: {
          color: '#333', // Tooltip arrow color
        },
      },
    },
  },
});

export default lightTheme;
